import { FC, useState } from 'react'
import { MaintainerModal } from '@/presentation/common/components/maintainer/MaintainerModal.tsx'
import { SidebarButton } from '@/presentation/common/components/SidebarButton.tsx'
import { useCrudAuth } from '@/presentation/common/hooks/crud/useCrudAuth.ts'
import { useActionsModal } from '@/presentation/common/hooks/useActionsModal.ts'
import { useMaintainerStore } from '@/presentation/common/store/zustand/maintainer.ts'
import {
  CreateMaintainerTemplateProductForm,
} from '@/presentation/productsTemplates/forms/CreateProductsTemplateProductForm.tsx'
import {
  DeleteMaintenanceProductsForm,
} from '@/presentation/productsTemplates/forms/DeleteProductsTemplateProductsForm.tsx'
import { ProductsTemplatesProductsActionsProps } from '@/presentation/productsTemplates/forms/types.ts'

export const ProductsTemplatesProductsActions: FC<ProductsTemplatesProductsActionsProps> = ({ onAction }) => {
  const selectionCount = useMaintainerStore((state) => state.selectionCountV2())

  const { canCreate, canDelete } = useCrudAuth()
  const { open, setOpen } = useActionsModal()
  const [ option, setOption ] = useState<'POST' | 'PUT' | 'DELETE' | null>(null)

  const isPost = option === 'POST'
  const isDelete = option === 'DELETE'

  const title = isPost ? 'Registrar producto' : 'Eliminar selección'

  const closeModal = () => {
    setOpen(false)
    setOption(null)
  }

  const onFinish = () => {
    closeModal()
    onAction?.()
  }

  return (
    <>
      <MaintainerModal title={title} open={open}>
        {isPost && <CreateMaintainerTemplateProductForm onCancel={closeModal} onFinish={onFinish}/>}
        {isDelete && <DeleteMaintenanceProductsForm onCancel={closeModal} onFinish={onFinish}/>}
      </MaintainerModal>

      {canCreate && (
        <SidebarButton label="Registrar producto" type="POST" onClick={() => {
          setOption('POST')
          setOpen(true)
        }}/>
      )}

      {canDelete && (
        <SidebarButton label={`Eliminar selección (${selectionCount})`} type="DELETE" onClick={() => {
          setOption('DELETE')
          setOpen(true)
        }}/>
      )}
    </>
  )
}
